<template>
  <div>
    <ServiceViewRightMenuPriceList_offers_discount
      :trans="trans"
      :enabled_first_time_offer_TimeOfferValue="
        enabled_first_time_offer_TimeOfferValue
      "
      :hasFirstTimeOffer="hasFirstTimeOffer"
      :serviceFirstTimeDiscountType_sign="serviceFirstTimeDiscountType_sign"
      :serviceFirstTimeOffer="serviceFirstTimeOffer"
      :notEmptyServiceDiscount="notEmptyServiceDiscount"
      :service_unit_price="service_unit_price"
      :unit="unit"
      :min_size_range="min_size_range"
      :per="per"
      :currency_symbol="currency_symbol"
      :service="service"
      :show_pricing_list_in_view_service_page="
        show_pricing_list_in_view_service_page
      "
      :display_button="display_button"
      :serviceDiscounts="serviceDiscounts"
      :currency="currency"
      :rates="rates"
      :websiteSettings="websiteSettings"
      :minPrice="minPrice"
    ></ServiceViewRightMenuPriceList_offers_discount>

    <!----------------------------[CUSTOM FIElDS PRICING ]--------------------------------->
    <div
      v-if="
        show_pricing_list_in_view_service_page == 1 && attributes.length != 0
      "
    >
      <div v-for="(attribute, index) in attributes" :key="index" id="attribute_pricing" class="col-md-3">
        <ul>
          <li >
            <div class="attribute_name">
              <h4>{{ attribute.attribute_name }}</h4>
            </div>
            <div
              class="attribute_price"
              v-if="attribute.attributeValuesPriceList"
            >
              <div
                class="col-xs-12 attribute"
                v-for="(
                  attributeValue, index
                ) in attribute.attributeValuesPriceList"
                :key="index"
              >
                <div class="col-xs-8 attribute_text text-left">
                  {{ attributeValue.attribute_value }}
                </div>
                <div
                  class="col-xs-4 attribute_value text-right"

                >
                  {{ currency_symbol }}{{ attributeValue.total_price }}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!----------------------------[END OF CUSTOM FIElDS PRICING ]--------------------------------->

    <a
      data-toggle="modal"
      v-if="
        websiteSettings.show_unit_price && (rates.length != 0 || display_button)
      "
      href="#responsive"
      class="btn btn-default get_quote hidden-xs hidden-sm "
    >
      {{ trans.view_full_pricing }}</a
    >

    <!-- ------------------------ [ Start Attributes Modal Section ] ------------------------ -->
    <service-view-right-menu-price-list_modal
      :trans="trans"
      :serviceFirstTimeDiscountType_sign="serviceFirstTimeDiscountType_sign"
      :serviceFirstTimeOffer="serviceFirstTimeOffer"
      :unit="unit"
      :min_size_range="min_size_range"
      :per="per"
      :currency_symbol="currency_symbol"
      :serviceDiscounts="serviceDiscounts"
      :websiteSettings="websiteSettings"
      :attributes="attributes"
      :minPrice="minPrice"
      :rates="rates"
      :currency="currency"
      :service="service"
    ></service-view-right-menu-price-list_modal>
    <!-- ------------------------ [ End Attributes  Modal Section ] ------------------------ -->
    <a
      v-if="
        websiteSettings.show_unit_price && (rates.length != 0 || display_button)
      "
      data-toggle="modal"
      href="#responsive"
      class="col-xs-12 hidden-md hidden-lg defualt-price btn btn-default get_quote attribute_pricing width-ipad-100" style="color: rgb(3, 169, 244);"
      >{{ trans.view_full_pricing }}</a
    >
  </div>
</template>

<script>
import { getServicePriceList } from '@/modules/CustomerPortal/api/services/view';
import ServiceViewRightMenuPriceList_offers_discount from './ServiceViewRightMenuPriceList_offers_discount';
import ServiceViewRightMenuPriceList_modal from './ServiceViewRightMenuPriceList_modal';

export default {
  name: 'ServiceViewRightMenuPriceList',
  components: {
    ServiceViewRightMenuPriceList_modal,
    ServiceViewRightMenuPriceList_offers_discount,
    getServicePriceList,
  },
  props: ['service_id', 'company_id', 'company_name'],
  data() {
    return {
      trans: [],
      enabled_first_time_offer_TimeOfferValue: 0,
      hasFirstTimeOffer: 0,
      serviceFirstTimeDiscountType_sign: '',
      serviceFirstTimeOffer: '',
      notEmptyServiceDiscount: 0,
      service_unit_price: 0,
      unit: 0,
      min_size_range: 0,
      per: '',
      currency_symbol: '',
      service: [],
      serviceDiscounts: [],
      websiteSettings: [],
      attributes: [],
      show_pricing_list_in_view_service_page: 0,
      display_button: 0,
      minPrice: 0,
      standardCost: 0,
      rates: [],
      currency: [],
    };
  },
  methods: {},
  computed: {},
  mounted() {
    getServicePriceList(
      this.service_id,
      this.company_name,
      this.company_id
    ).then((response) => {
      if (response.status == 200) {
        if (response.data.type == 'success') {
          this.trans = response.data.data.trans;
          this.service = response.data.data.service;
          this.attributes = response.data.data.attributes;
          this.enabled_first_time_offer_TimeOfferValue =
            response.data.data.enabled_first_time_offer_TimeOfferValue;
          this.hasFirstTimeOffer = response.data.data.hasFirstTimeOffer;
          this.serviceFirstTimeOffer = response.data.data.serviceFirstTimeOffer;
          this.notEmptyServiceDiscount =
            response.data.data.notEmptyServiceDiscount;
          this.service_unit_price = response.data.data.service_unit_price;
          this.unit = response.data.data.unit;
          this.min_size_range = response.data.data.min_size_range;
          this.per = response.data.data.per;
          this.currency_symbol = response.data.data.currency_symbol;
          this.serviceDiscounts = response.data.data.serviceDiscount;
          this.serviceFirstTimeDiscountType_sign =
            response.data.data.serviceFirstTimeDiscountType_sign;
          this.show_pricing_list_in_view_service_page =
            response.data.data.show_pricing_list_in_view_service_page;
          this.display_button = response.data.data.display_button;
          this.websiteSettings = response.data.data.websiteSettings;
          this.minPrice = response.data.data.minPrice;
          this.standardCost = response.data.data.standardCost;
          this.currency = response.data.data.currency;
          this.rates = response.data.data.rates;
        }
      }
    });
  },
};
</script>
<style>
@media (max-width: 767px) {
  .attribute_pricing {
    width: 94% !important;
    float: left !important;
    margin-left: 3% !important;
  }
}
@media (min-width: 768px) and (max-width: 1000px){
  .attribute_pricing {
    width: 100% !important;
  }
}
</style>